import { render, staticRenderFns } from "./bargainPriceRouter.vue?vue&type=template&id=68469b18&scoped=true&"
import script from "./bargainPriceRouter.vue?vue&type=script&lang=js&"
export * from "./bargainPriceRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68469b18",
  null
  
)

export default component.exports